import PersistentStore from "@/api/PersistentStore";
import { ErrorTypes } from "@/api/request";
import { RootState } from "@/store/types";
import { Module } from "vuex";
import { actions } from "./actions";
import { configs } from "./config";
import { getters } from "./getters";
import { mutations } from "./mutations";
import { PatientState } from "./types";

export const TOWER_MODE_KEY = "towerMode";

export const initialState = function(): PatientState {
  const towerModeSaved = PersistentStore.getItem(TOWER_MODE_KEY, null);
  let towerMode = !!process.env.VUE_APP_TOWER;
  if (towerModeSaved === false || towerModeSaved === true) {
    towerMode = towerModeSaved;
  }

  return {
    patientList: [],
    censusLoaded: false,
    activePatientId: null,
    error: ErrorTypes.NONE,
    errorStack: "",
    errorMessage: "",
    errorUrl: "",
    stats: {
      alertReviews: 0,
      cases: 0,
      now: "",
      dateTimeOffset: 0,
      reviewsComplete: 0,
      reviewsSent: 0,
      start: ""
    },
    vars: {},
    varsLoaded: false,
    configs: configs,
    careNote: "",
    towerMode,
    verifyMode: false,
    singlePatientView: false,
    audioAlerts: {},
    isTesting: false,
    isPagingTest: false,
    isPagingTestActive: false,
    isActiveTesting: false,
    medList: []
  };
};

export const state: PatientState = initialState();

export const patientNamespace = { namespace: "patient" };

const namespaced: boolean = true;

export const patient: Module<PatientState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
